import { render } from "./EmployeesForm.vue?vue&type=template&id=938ad316"
import script from "./EmployeesForm.vue?vue&type=script&lang=ts"
export * from "./EmployeesForm.vue?vue&type=script&lang=ts"
script.render = render

export default script